import closeIcon from "../../../global-assets/assets/icon-close-gray.svg";
import Button from "../../common/Button";

interface CookieConsentProps {
  onClose: () => void;
}

export function CookieConsentModal({ onClose }: CookieConsentProps) {
  return (
    <div className="fixed bottom-[20%] left-1/2 transform -translate-x-1/2 z-[20] flex flex-col items-center text-center bg-white p-6 px-12 rounded-[10px] w-auto max-w-full shadow-lg lg:flex-row lg:justify-between lg:text-left">
      <img
        className="absolute top-3 left-4 border-none bg-transparent cursor-pointer max-w-[10px]"
        src={closeIcon}
        onClick={onClose}
        loading="lazy"
        alt=""
      />
      <div className="flex flex-col items-center lg:items-start lg:max-w-[90%]">
      <p className="text-base lg:mr-8 lg:mb-2 lg:max-w-[80%] lg:leading-[1.4]">
          Most cookies we eat, but TruPlay uses cookies on our website to
          deliver a better experience.
        </p>
        <a href="/privacy-policy#third-party-cookies" target="blank" className="text-[#626d7d] font-sans text-base font-semibold">
          Learn More
        </a>
      </div>
      <div className="mt-4">
        <Button id="cookie_accept_all_btn" onClick={onClose} btnType="blue" className="py-2 px-6 my-4 w-[200px]">
          Accept
        </Button>
        {/* <Button id="cookie_reject_all_btn" onClick={onClose} btnType="outline" className="py-2 px-6 my-4 w-[200px]">
          Reject
        </Button> */}
      </div>
    </div>
  );
}